import { FlexBox, Icon } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../lib/ctx/stats'
import { useClickOutside } from '@fable/hooks'
import { useRef, useState } from 'react'
import { useMotionValueEvent, useScroll } from 'framer-motion'
import { StatsShareModalImage } from './StatsShareModalImage'

export const StatsShareModal = () => {
  const { colors } = useTheme()
  const [open, close, options, isProfileView, isDesktop] = useStats((s) => [
    s.isSharing,
    s.closeShareModal,
    s.shareModalOptions,
    s.isProfileView,
    s.isDesktop,
  ])
  const modalRef = useRef<HTMLDivElement>(null)
  const testId = options?.type ? `-${options.type}` : ''
  const { scrollY } = useScroll()
  const [scrolled, setScrolled] = useState(false)
  const isProfileOnMobile = !isDesktop && isProfileView

  useMotionValueEvent(scrollY, 'change', (pos) => {
    setScrolled(pos > 0)
  })

  useClickOutside(modalRef, () => open && close())

  return (
    <FlexBox
      className={css`
        width: 100%;
        height: 100dvh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        opacity: ${open ? 1 : 0};
        pointer-events: ${open ? 'auto' : 'none'};
        transition: opacity 0.2s ease;
        user-select: none;
        background-color: ${isDesktop ? 'rgba(0, 0, 0, 0.1)' : 'transparent'};
      `}
      justifyContent="center"
    >
      <FlexBox
        className={css`
          padding: 0 20px;
          padding-top: ${isProfileOnMobile && scrolled ? '60px' : 0};
          width: 100%;
          max-width: 420px;
          height: 100%;
          justify-content: center;
          align-items: ${isProfileOnMobile ? 'flex-start' : 'center'};
        `}
        centerAll
      >
        <FlexBox
          ref={modalRef}
          data-testid={`stats-share-modal${testId}`}
          className={css`
            padding: 20px;
            width: 100%;
            background-color: ${colors.uiWhite};
            border-radius: 12px;
            position: relative;
            gap: 12px;
            max-height: ${isProfileOnMobile ? '80%' : '90%'};
            overflow-y: auto;
            box-shadow: 0px 8px 36px 0px rgba(0, 0, 0, 0.17);
          `}
          flexDirection="column"
        >
          <FlexBox
            className={css`
              width: 24px;
              height: 24px;
              background-color: ${colors.uiPearlExtraLight};
              align-self: flex-end;
              border-radius: 50%;
              flex-shrink: 0;
            `}
            aria-label="close share modal"
            onClick={close}
            centerAll
          >
            <Icon
              className={css`
                width: 16px;
              `}
              type="close"
              fill={colors.uiGraphite}
            />
          </FlexBox>
          {!!options?.component ? <StatsShareModalImage /> : null}
        </FlexBox>
      </FlexBox>
    </FlexBox>
  )
}
